import React, { Component } from "react";
import { Link } from "react-router-dom";
import { theme } from "../../assets/theme/theme";

class TrainingEvaluationDetail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      form: {
        content_rating: "",
        trainer_rating: "",
        material_rating: "",
        venue_rating: "",
        overall_rating: "",
        learning_outcome: "",
        work_application: "",
        improvement_feedback: "",
        recommendation: "",
      },
    };
  }

  updateForm = (key, value) => {
    this.setState({
      form: {
        ...this.state.form,
        [key]: value,
      },
    });
  };

  renderRating(label, key) {
    return (
      <div style={{ marginBottom: 18 }}>
        <label style={labelStyle}>{label}</label>

        <div style={{ display: "flex", gap: 10 }}>
          {[1, 2, 3, 4, 5].map((score) => {
            const active = Number(this.state.form[key]) === score;

            return (
              <button
                key={score}
                type="button"
                onClick={() => this.updateForm(key, score)}
                style={{
                  width: 42,
                  height: 38,
                  borderRadius: 8,
                  border: active
                    ? `1px solid ${theme.colors.brand.primary}`
                    : "1px solid #CBD5E1",
                  background: active ? theme.colors.brand.primary : "#fff",
                  color: active ? "#fff" : "#334155",
                  fontWeight: 800,
                  cursor: "pointer",
                }}
              >
                {score}
              </button>
            );
          })}
        </div>
      </div>
    );
  }

  renderTextarea(label, key, placeholder) {
    return (
      <div style={{ marginBottom: 18 }}>
        <label style={labelStyle}>{label}</label>
        <textarea
          rows={5}
          placeholder={placeholder}
          value={this.state.form[key]}
          onChange={(e) => this.updateForm(key, e.target.value)}
          style={textareaStyle}
        />
      </div>
    );
  }

  renderInfoRow(label, value) {
    return (
      <div style={{ marginBottom: 14 }}>
        <div style={{ fontSize: 12, color: "#64748B", fontWeight: 700 }}>{label}</div>
        <div style={{ fontSize: 14, color: "#0F172A", fontWeight: 700, marginTop: 4 }}>
          {value}
        </div>
      </div>
    );
  }

  renderSection(title, children) {
    return (
      <div
        style={{
          background: "#fff",
          border: "1px solid #E5E7EB",
          borderRadius: 12,
          padding: 20,
          marginBottom: 18,
        }}
      >
        <h5 style={{ margin: "0 0 18px", fontWeight: 800 }}>{title}</h5>
        {children}
      </div>
    );
  }

  getAverageScore() {
    const keys = [
      "content_rating",
      "trainer_rating",
      "material_rating",
      "venue_rating",
      "overall_rating",
    ];

    const values = keys
      .map((key) => Number(this.state.form[key]))
      .filter((value) => value > 0);

    if (!values.length) return "-";

    const total = values.reduce((sum, value) => sum + value, 0);
    return (total / values.length).toFixed(1);
  }

  render() {
    const data = {
      evaluation_id: "EVA-2026-001",
      request_id: "TRN-2026-0012",
      course: "Digital Marketing Masterclass",
      provider: "AIM Academy",
      completed_date: "17 Jun 2026",
      due_date: "24 Jun 2026",
      status: "Pending",
      participant: "Ho Boon Hock",
      department: "Digitalisation",
    };

    return (
      <div style={{ padding: 24 }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            marginBottom: 20,
          }}
        >
          <div>
            <Link
              to="/training/evaluations"
              style={{
                color: theme.colors.brand.primary,
                fontSize: 13,
                fontWeight: 700,
                textDecoration: "none",
              }}
            >
              ← Back to Training Evaluations
            </Link>

            <h4 style={{ margin: "12px 0 6px", fontWeight: 800 }}>
              Training Evaluation
            </h4>

            <div style={{ color: "#64748B", fontSize: 13 }}>
              {data.evaluation_id} · {data.request_id}
            </div>
          </div>

          <div
            style={{
              background: "#FFF7E6",
              color: "#B76E00",
              padding: "7px 12px",
              borderRadius: 8,
              fontSize: 12,
              fontWeight: 800,
            }}
          >
            {data.status}
          </div>
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1.45fr 0.75fr",
            gap: 18,
          }}
        >
          <div>
            {this.renderSection(
              "Evaluation Form",
              <div>
                {this.renderRating("Course content quality", "content_rating")}
                {this.renderRating("Trainer / facilitator effectiveness", "trainer_rating")}
                {this.renderRating("Training materials usefulness", "material_rating")}
                {this.renderRating("Venue / online platform suitability", "venue_rating")}
                {this.renderRating("Overall training satisfaction", "overall_rating")}

                <div
                  style={{
                    marginTop: 8,
                    padding: 14,
                    background: "#F8FAFC",
                    borderRadius: 8,
                    display: "flex",
                    justifyContent: "space-between",
                    fontWeight: 800,
                  }}
                >
                  <span>Average Score</span>
                  <span>{this.getAverageScore()}</span>
                </div>
              </div>
            )}

            {this.renderSection(
              "Learning Outcome",
              <div>
                {this.renderTextarea(
                  "What key knowledge or skills did you gain?",
                  "learning_outcome",
                  "Describe the main learning outcome from this training."
                )}

                {this.renderTextarea(
                  "How will you apply this training to your work?",
                  "work_application",
                  "Describe how this training can improve your work performance."
                )}

                {this.renderTextarea(
                  "Suggestions for improvement",
                  "improvement_feedback",
                  "Share any feedback about the course, trainer, venue or content."
                )}
              </div>
            )}

            {this.renderSection(
              "Recommendation",
              <div>
                <label style={labelStyle}>
                  Would you recommend this training to other colleagues?
                </label>

                <select
                  value={this.state.form.recommendation}
                  onChange={(e) => this.updateForm("recommendation", e.target.value)}
                  style={inputStyle}
                >
                  <option value="">Select</option>
                  <option value="yes">Yes</option>
                  <option value="no">No</option>
                  <option value="maybe">Maybe</option>
                </select>
              </div>
            )}

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: 22,
              }}
            >
              <Link to="/training/evaluations" style={secondaryButtonLink}>
                Cancel
              </Link>

              <div style={{ display: "flex", gap: 10 }}>
                <button style={secondaryButton}>Save Draft</button>
                <button style={primaryButton}>Submit Evaluation</button>
              </div>
            </div>
          </div>

          <div>
            {this.renderSection(
              "Training Summary",
              <div>
                {this.renderInfoRow("Course / Program", data.course)}
                {this.renderInfoRow("Provider", data.provider)}
                {this.renderInfoRow("Participant", data.participant)}
                {this.renderInfoRow("Department", data.department)}
                {this.renderInfoRow("Completed Date", data.completed_date)}
                {this.renderInfoRow("Evaluation Due Date", data.due_date)}
              </div>
            )}

            {this.renderSection(
              "Rating Guide",
              <div>
                {[
                  ["1", "Poor"],
                  ["2", "Fair"],
                  ["3", "Good"],
                  ["4", "Very Good"],
                  ["5", "Excellent"],
                ].map((row) => (
                  <div
                    key={row[0]}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "9px 0",
                      borderBottom: "1px solid #EEF2F7",
                      fontSize: 13,
                    }}
                  >
                    <span style={{ fontWeight: 800 }}>{row[0]}</span>
                    <span style={{ color: "#64748B" }}>{row[1]}</span>
                  </div>
                ))}
              </div>
            )}

            {this.renderSection(
              "Reminder",
              <div style={{ fontSize: 13, color: "#475569", lineHeight: "22px" }}>
                Please submit the evaluation within 7 days after the training completion date.
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const labelStyle = {
  display: "block",
  fontSize: 12,
  fontWeight: 800,
  color: "#334155",
  marginBottom: 8,
};

const inputStyle = {
  width: "100%",
  height: 40,
  border: "1px solid #CBD5E1",
  borderRadius: 8,
  padding: "0 12px",
  fontSize: 13,
  outline: "none",
};

const textareaStyle = {
  width: "100%",
  border: "1px solid #CBD5E1",
  borderRadius: 8,
  padding: 12,
  fontSize: 13,
  outline: "none",
  resize: "vertical",
};

const primaryButton = {
  background: theme.colors.brand.primary,
  color: "#fff",
  border: 0,
  borderRadius: 8,
  padding: "10px 18px",
  fontWeight: 800,
  cursor: "pointer",
};

const secondaryButton = {
  background: "#fff",
  color: "#334155",
  border: "1px solid #CBD5E1",
  borderRadius: 8,
  padding: "9px 16px",
  fontWeight: 800,
  cursor: "pointer",
};

const secondaryButtonLink = {
  ...secondaryButton,
  display: "inline-block",
  textDecoration: "none",
};

export default TrainingEvaluationDetail;